import {
  CHECKING_RESET_PASSWORD_TOKEN,
  RESENDING_VERIFY_EMAIL,
  SENDING_FORGET_PASSWORD_LINK,
  SENDING_RESET_PASSWORD_LINK,
  SET_IDENTIFICATION,
  SET_USER_REGISTER_FORM_DONE,
  UPDATING_USER,
  USER_ROLE,
  USER_LOGGING,
  USER_LOGIN_DONE,
  USER_LOGOUT_DONE,
  USER_REGISTERING,
} from './constants';

export default {
  [CHECKING_RESET_PASSWORD_TOKEN](state, checking) {
    state.checkingResetPasswordToken = checking;
  },
  [RESENDING_VERIFY_EMAIL](state, resending) {
    state.resending = resending;
  },
  [SENDING_FORGET_PASSWORD_LINK](state, sending) {
    state.sendingForgetPwdLink = sending;
  },
  [SENDING_RESET_PASSWORD_LINK](state, sending) {
    state.sendingResetPwdLink = sending;
  },
  [SET_IDENTIFICATION](state, identification) {
    state.identification = identification;
  },
  [SET_USER_REGISTER_FORM_DONE](state, payload) {
    state.registerForm = { ...state.registerForm, ...payload };
  },
  [UPDATING_USER](state, updating) {
    state.updatingUser = updating;
  },
  [USER_LOGGING](state, logging) {
    state.logging = logging;
  },
  [USER_LOGIN_DONE](state, token) {
    state.token = token;
  },
  [USER_LOGOUT_DONE](state) {
    state.token = null;
  },
  [USER_REGISTERING](state, registering) {
    state.registering = registering;
  },
  [USER_ROLE](state, role) {
    state.role = role;
  },
};
